// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2c2_d","info":"Note_info__3YkIx","note":"Note_note__HHsv0","actions":"Note_actions__3t49a"};